export default __webpack_public_path__ + "assets/icons/contact_mobile_no.945c1f89.svg";